"use client"

import dynamic from "next/dynamic"
import { useEffect } from "react"

import { chatApiOrigin } from "@/lib/config/environments"
import { usePromotionBannerOpen } from "@/lib/promotionBannerOpenStore"

const AnonymousChat = dynamic(
  () =>
    import("trimble-terra/AnonymousChat").then((mod) => mod.AnonymousChat),
  { ssr: false },
)

const LOCALHOST_HOSTNAMES = new Set(["localhost", "127.0.0.1"])

/** Thin MXP wrapper. Renders nothing when NEXT_PUBLIC_CHAT_API_ORIGIN is unset. */
export default function AnonymousChatWidget() {
  const isPromotionBannerOpen = usePromotionBannerOpen()

  // The widget's FAB only re-positions itself above the OneTrust cookie
  // banner (it has no concept of this app's bottom-docked PromotionBanner),
  // so toggle an attribute on <html> for terra.css to push the FAB above
  // the banner using the same --promotion-banner-height var FrontdoorAgentFlyout
  // and ScrollToTop already rely on.
  useEffect(() => {
    document.documentElement.toggleAttribute(
      "data-promotion-banner-open",
      isPromotionBannerOpen,
    )
    return () => {
      document.documentElement.removeAttribute("data-promotion-banner-open")
    }
  }, [isPromotionBannerOpen])

  if (!chatApiOrigin) return null

  // The upstream's CORS allow-list rejects browser requests from localhost,
  // so on localhost route through the same-origin /api/chat-proxy (which
  // forwards server-to-server to chatApiOrigin with no Origin header).
  // Everywhere else, call chatApiOrigin directly.
  const isLocalhost =
    typeof window !== "undefined" &&
    LOCALHOST_HOSTNAMES.has(window.location.hostname)
  const apiOrigin = isLocalhost
    ? `${window.location.origin}/api/chat-proxy`
    : chatApiOrigin

  return <AnonymousChat apiOrigin={apiOrigin} />
}
